jQuery(document).ready(function ($) {
  // Akkordeon für die übergeordneten Taxonomien
  $('.taxonomy-name').not('.taxonomy-sub').click(function (event) {
    event.preventDefault();
    var _this = this;
    var $target = $(_this).next('.taxonomy-content');
    $target.slideToggle();
    $(_this).toggleClass('is-open');
    if ($(_this).hasClass('is-open')) {
      accordeonScrollTo($(_this));
    }
  });

  var accordeonScrollTo = function (target) {
    var t = target;
    var $page = $('html, body');

    $page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
      $page.stop();
    });

    $page.animate({
      scrollTop: t.offset().top - 40,
    }, 'slow', function () {
        $page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
      });

    return false;
  };
});